;(function () {
  'use strict'

  angular.module('contrast.time-series').directive('csTimeSeries', csTimeSeries)

  function csTimeSeries(
    $compile,
    $window,
    d3,
    dc,
    crossfilterService,
    ProfileService
  ) {
    'ngInject'

    var uniqueId = 1

    return {
      restrict: 'E',
      scope: {
        data: '=',
        interval: '=',
        fillHeight: '=',
        maxHeight: '=',
        paddedWidth: '='
      },
      link: link
    }

    function link($scope, element) {
      var dateFormat = ProfileService.getDateFormat()

      var id = 'time-series-' + uniqueId++,
        parent = element.parent(),
        rendering = false,
        preRender = false

      element.attr('id', id)
      var chart = dc.compositeChart('#' + id).renderTitle(false)

      $scope.$watch(
        function () {
          return $scope.data ? $scope.data.data : $scope.$parent.data.data
        },
        function (newValue) {
          if (newValue) {
            renderChart(true)
          }
        }
      )

      $scope.$watch(
        function () {
          return parent.width() + element.width()
        },
        function (newValue, oldValue) {
          if (newValue && newValue !== oldValue) {
            renderChart()
          }
        },
        true
      )

      function renderChart(force) {
        if ($scope.data && $scope.data.data && (!rendering || force)) {
          rendering = true

          element.addClass('timeseries-loading')

          var ndx = crossfilterService($scope.data.data),
            timeDimension = ndx.dimension(function (d) {
              return d.timestamp
            })

          var parentWidth = parent.width(),
            compose = []

          angular.forEach($scope.data.config, function (config) {
            var radius = config.hidePoint ? 6 : 4

            var valueGroup = timeDimension.group().reduceSum(config.group)
            var lineChart = dc
              .lineChart(chart)
              .group(valueGroup)
              .dotRadius(5)
              .renderArea(true)
              .renderDataPoints({
                radius: radius
              })
              .clipPadding(0)

            compose.push(lineChart)
          })

          var formatFunction = null
          var xAxisValues = []
          var startDate = null
          var endDate = null
          var tooltip = null
          var tooltipOverride = $scope.data.tooltipOverride
          var custom = $scope.interval.custom

          if (angular.isDefined(custom)) {
            formatFunction = custom.formatFunction
            xAxisValues = custom.xAxisValues
            startDate = custom.startDate
            endDate = custom.endDate
            tooltip = custom.tooltip
          } else {
            var includeToday = $scope.interval.includeToday
            var showToday = $scope.data.showToday

            switch ($scope.interval.text) {
              //Work on setting formats based on interval
              case 'Last 30 Days':
                startDate = moment().subtract(1, 'months').toDate()
                if (includeToday) {
                  endDate = moment().toDate()
                } else {
                  endDate = moment().subtract(1, 'days').toDate()
                }
                tooltip = 'timeSeriesOverallTooltip.html'
                var weekday = d3.time.format('%A')(new Date()).toLowerCase()
                formatFunction = function (val) {
                  if (showToday && moment().isSame(val, 'day')) {
                    return 'TODAY'
                  }
                  return d3.time.format('%b %e')(val).toUpperCase()
                }
                xAxisValues = d3.time[weekday + 's'](startDate, endDate)
                break

              case 'Last 12 Months':
                startDate = moment()
                  .startOf('month')
                  .subtract(1, 'years')
                  .toDate()
                if (includeToday) {
                  endDate = moment().startOf('month').toDate()
                } else {
                  endDate = moment()
                    .startOf('month')
                    .subtract(1, 'months')
                    .toDate()
                }
                tooltip = 'timeSeriesYearTooltip.html'
                formatFunction = function (val) {
                  return d3.time.format('%b')(val).toUpperCase()
                }
                var allMonths = d3.time.months(startDate, endDate)

                //Get Every Other Month
                for (var i = 0; i < allMonths.length; i++) {
                  if (i % 2 === 0) {
                    xAxisValues.push(allMonths[i])
                  }
                }
                break

              case 'Last 7 Days':
              default:
                if (includeToday) {
                  startDate = moment().subtract(7, 'days').toDate()
                  endDate = moment().toDate()
                } else {
                  startDate = moment().subtract(8, 'days').toDate()
                  endDate = moment().subtract(1, 'days').toDate()
                }
                tooltip = 'timeSeriesOverallTooltip.html'
                formatFunction = function (val) {
                  return d3.time.format('%a')(val).toUpperCase()
                }
                xAxisValues = d3.time.days(startDate, endDate)
                break
            }
          }

          if (tooltipOverride && angular.isString(tooltipOverride)) {
            tooltip = tooltipOverride
          }

          var height = 200
          if ($scope.fillHeight) {
            var parentHeight = parent.height(),
              siblingHeight = 0

            parent.children().each(function (index, ele) {
              if (ele.id !== element[0].id) {
                siblingHeight += angular.element(ele).height()
              }
            })

            if (siblingHeight > 0) {
              height = parentHeight - siblingHeight
            }

            height = height <= 10 ? parentHeight : height

            if (
              $scope.maxHeight &&
              !isNaN($scope.maxHeight) &&
              height > $scope.maxHeight
            ) {
              height = $scope.maxHeight
            }
            if (angular.isNumber($scope.fillHeight)) {
              height = Math.max(height, $scope.fillHeight)
            }
          }

          element.css('height', height + 'px')

          var paddedWidth = $scope.paddedWidth || 90

          chart
            .width(parentWidth + paddedWidth)
            .height(height)
            .clipPadding(10)
            .x(d3.time.scale().domain([startDate, endDate]))
            .dimension(timeDimension)
            .brushOn(false)
            .compose(compose)
            .y(
              d3.scale
                .linear()
                .domain([
                  $scope.data.min ? $scope.data.min : 0,
                  $scope.data.max
                ])
            )

          chart.xAxis().tickFormat(formatFunction)

          chart.xAxis().tickValues(xAxisValues)

          chart.on('postRender', function (chart) {
            var i = 0
            angular.forEach($scope.data.config, function (config) {
              if (!config.tooltipTemplate) {
                config.tooltipTemplate = tooltip
              }
              chart
                .selectAll('g.sub._' + i + ' g.dc-tooltip-list .dot')
                .attr(
                  'template',
                  "'views/tooltips/" + config.tooltipTemplate + "'"
                )
                .attr('cs-time-series-tooltip', '')
                .attr('display-value', function (v) {
                  return v.data.value
                })
                .attr('display-time', function (v) {
                  return v.data.key
                })
                .attr('display-date-format', dateFormat)
                .attr('display-title', config.tooltip.title)
                .attr('display-class', config.tooltip.class)
                .attr('display-position', config.tooltip.position || 'top')

              var group = chart.select('g.sub._' + i)
              group.classed(config.class, true)

              var defs = chart.select('defs'),
                gradientId = id + '_linear_' + i
              var linearGradient = defs
                .append('linearGradient')
                .attr('id', gradientId)
                .attr('x1', '0%')
                .attr('y1', '0%')
                .attr('x2', '0%')
                .attr('y2', '100%')

              linearGradient
                .append('stop')
                .attr('offset', '0%')
                .classed(config.class + '-gradient-start', true)

              linearGradient
                .append('stop')
                .attr('offset', '100%')
                .classed(config.class + '-gradient-end', true)

              chart
                .select('g.sub._' + i + ' .stack._0 .area')
                .attr('fill', 'url(#' + gradientId + ')')
                .classed('no-pointer-events', true)

              if (config.yAxisLines) {
                var axisData = _.map(config.yAxisLines, function (axisLine) {
                  return [
                    {
                      x: -10,
                      y: chart.y()(axisLine.value)
                    },
                    {
                      x: chart.width() - 70,
                      y: chart.y()(axisLine.value)
                    }
                  ]
                })

                var lineFunction = d3.svg
                  .line()
                  .x(function (d) {
                    return d.x
                  })
                  .y(function (d) {
                    return d.y
                  })
                  .interpolate('linear')

                chart
                  .select('g.sub._' + i + ' g.dc-tooltip-list')
                  .selectAll('.cs-axis-line')
                  .data(axisData)
                  .enter()
                  .append('path')
                  .classed('cs-axis-line', true)
                  .attr('d', lineFunction)
                  .attr('stroke-dasharray', '5,5')

                chart
                  .g()
                  .append('g')
                  .classed('cs-axis-line-text-g _' + i, true)
                  .attr('transform', 'translate(30,10)')
                  .selectAll('.cs-axis-line-text')
                  .data(config.yAxisLines)
                  .enter()
                  .append('text')
                  .classed('cs-axis-line-text', true)
                  .attr('dy', '0.27em')
                  .attr('x', chart.width() - 70)
                  .attr('y', function (axisLine) {
                    return chart.y()(axisLine.value)
                  })
                  .attr('cs-time-series-tooltip', '')
                  .attr(
                    'template',
                    "'views/tooltips/timeSeriesValueTooltip.html'"
                  )
                  .attr('display-value', function (axisLine) {
                    return axisLine.tooltipContent
                  })
                  .attr('display-position', 'right')
                  .text(function (axisLine) {
                    return axisLine.value
                  })
              }

              i++
            })

            if (preRender) {
              $compile(element)($scope)
            }
            preRender = false
            rendering = false

            if (parentWidth !== parent.width()) {
              renderChart(true)
            } else {
              element.removeClass('timeseries-loading')
            }
          })

          preRender = true
          chart.render()
        }
      }

      function onResize() {
        $scope.$digest()
      }

      angular.element($window).on('resize', onResize)

      function onDestroy() {
        angular.element($window).off('resize', onResize)
      }

      $scope.$on('$destroy', onDestroy)
    }
  }
})()
